export const SIGNIN_FORM = 'SIGNIN_FORM';

export const WRONG_FM_MODAL = 'WRONG_FM_MODAL';

export const SEGMENT_ANONYMOUS_ID = 'ajs_anonymous_id';

//TODO: Need to check of usage, seems redundant
export const MIGRATION_ERRORS = ['120', '129'];

export const NOTIFY_MIGRATED_CLIENT_PERIOD_IN_DAYS = 60;

export const SIGN_IN_STATUS = {
  SUCCESS: 'success',
  NEED_MFA: 'needMfa',
  PASSWORD_CHANGE_REQUIRED: 'passwordChangeRequired',
  REQUIRED_VERIFICATION: 'requiredVerification',
  REQUIRED_PHONE_VERIFICATION: 'requiredPhoneVerification',
  SETUP_MFA: 'setupMfa',
};

export const REQUIRED_VERIFICATION_MODAL = 'REQUIRED_VERIFICATION_MODAL';
